import {
  Box,
  BoxProps,
  Button,
  Center,
  HStack,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import {
  AppButton,
  DateDisplay,
  UserLabel,
} from 'features/components';
import { useCallback, useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import {
  AfeUploadDocumentsDrawer,
  AfeUploadDocumentsDrawerProps,
} from './AfeUploadDocumentsDrawer';
import { useAuth } from 'core';
import { toast } from 'toast';
import { AfeResponse } from 'api/bindings/AfeResponse';
import { AfeDocumentUrlResponse } from 'api/bindings/AfeDocumentUrlResponse';

export interface AfeDocumentsSectionProps extends BoxProps {
  afe: AfeResponse | undefined;
  onUpload: () => void;
}

export const AfeDocumentsSection = (props: AfeDocumentsSectionProps) => {
  const { afe, onUpload, ...rest } = props;

  const auth = useAuth();
  const [drawerSettings, setDrawerSettings] =
    useState<Omit<AfeUploadDocumentsDrawerProps, 'onClose' | 'onUpload'>>();

  const handleDownloadDocument = useCallback(
    async (afeId: string, fileName: string) => {
      const response = await fetch(
        `/api/afes/${afeId}/documents/${encodeURI(
          fileName
        )}?noredirect=1&clientId=${auth?.user.clientId}`,
        {
          headers: {
            Authorization: `Bearer ${auth?.jwt}`,
            'Content-Type': `application/json`,
          },
        }
      );

      if (!response.ok) {
        toast({
          status: 'error',
          title: 'Error while requesting document',
        });
        console.debug(`download document error:`, await response.text());
        return;
      }

      const jsonData: AfeDocumentUrlResponse = await response.json();
      window.open(jsonData.url, '_blank');
    },
    [auth?.jwt, auth?.user.clientId]
  );

  return (
    <Box {...rest}>
      {drawerSettings && (
        <AfeUploadDocumentsDrawer
          {...drawerSettings}
          onUpload={onUpload}
          onClose={() => setDrawerSettings(undefined)}
        />
      )}
      <Stack gap={4}>
        <HStack>
          <AppButton
            colorScheme="blue"
            variant="solid"
            leftIcon={
              // @ts-ignore
              <FiPlus />
            }
            onClick={() => setDrawerSettings({ afe, isOpen: true })}
          >
            Upload Attachments
          </AppButton>
        </HStack>
        <TableContainer>
          <Table>
            <Thead>
              <Tr>
                <Th>Document</Th>
                <Th>Uploaded By</Th>
                <Th>Upload Date</Th>
              </Tr>
            </Thead>
            <Tbody>
              {!afe?.documents?.length && (
                <Tr>
                  <Td colSpan={3}>
                    <Center>No Documents Available</Center>
                  </Td>
                </Tr>
              )}
              {afe?.documents?.map((doc, i) => (
                <Tr key={i}>
                  <Td>
                    <Button
                      as="a"
                      onClick={() =>
                        handleDownloadDocument(doc.afeId, doc.fileName)
                      }
                    >
                      {doc.fileName}
                    </Button>
                    {/* <AppLink
                      to={`/api/afe/${afe?.id}/documents/${decodeURI(
                        doc.fileName
                      )}?clientId=${auth?.user.clientId ?? 0}`}
                      target="_blank"
                    >
                      {doc.fileName}
                    </AppLink> */}
                  </Td>
                  <Td>
                    <UserLabel value={doc.createdById} />
                  </Td>
                  <Td>
                    <DateDisplay value={doc.createdAt} />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
};
